export let matriceNavigationEtapesSansPieceMap = new Map<number, string[]>([
    [1, ['informationDetenu.statutInfoDetenu.statutNomDetenu', 'informationDetenu.statutInfoDetenu.statutPrenomDetenu']],
    [4, ['informationVisiteur.statutInfoVisiteur.statutSexe', 'informationVisiteur.statutInfoVisiteur.statutPrenomVisiteur',
        'informationVisiteur.statutInfoVisiteur.statutNomVisiteur', 'informationVisiteur.statutInfoVisiteur.statutDateNaissance']],
    [5, ['informationVisiteur.statutInfoVisiteur.statutPaysNaissance',
        'informationVisiteur.statutInfoVisiteur.statutVilleNaissance',
        'informationVisiteur.statutInfoVisiteur.statutVilleEtrangere',
        'informationVisiteur.statutInfoVisiteur.statutNationalite',
        'informationVisiteur.statutInfoVisiteur.statutEmail']],
    [7, ['informationVisiteur.statutInfoVisiteur.statutNomMajeur',
        'informationVisiteur.statutInfoVisiteur.statutPrenomMajeur',
        'informationVisiteur.statutInfoVisiteur.statutNumeroPvMajeur']],
    [9, ['informationVisiteur.statutInfoVisiteur.statutType']],
    [11, ['informationVisiteur.statutInfoVisiteur.statutTypePi',
        'informationVisiteur.statutInfoVisiteur.statutNumeroPi',
        'informationVisiteur.statutInfoVisiteur.statutAutoriteDelivPi']],
    [13, ['informationVisiteur.statutInfoVisiteur.statutTypeJustificatifMineur']],
]);
